import { render, staticRenderFns } from "./ShieldIcon.vue?vue&type=template&id=6f0d037c&"
import script from "./ShieldIcon.vue?vue&type=script&lang=js&"
export * from "./ShieldIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports